import { z } from "zod";
export const VENUS_RESPONSE_PROBABILITIES_EVENT = "model.response.probabilities";
/** UTF-16 offsets into visible assistant Markdown; gaps are deliberately unscored. */
export const venusResponseProbabilitiesSchema = z.object({
    version: z.literal(1), callKey: z.string().min(1), model: z.string().min(1),
    source: z.literal("generation-before-sampling"),
    text: z.string().min(1).max(65_536),
    tokens: z.array(z.object({
        start: z.number().int().nonnegative(), end: z.number().int().positive(),
        logprob: z.number().finite().max(0),
    }).strict()).min(1).max(8192),
}).strict().superRefine((trace, ctx) => {
    let end = 0;
    for (const token of trace.tokens) {
        const splitsSurrogate = (offset) => offset > 0 &&
            /[\uD800-\uDBFF]/.test(trace.text[offset - 1]) && /[\uDC00-\uDFFF]/.test(trace.text[offset] ?? "");
        if (token.start < end || token.end <= token.start || token.end > trace.text.length ||
            splitsSurrogate(token.start) || splitsSurrogate(token.end)) {
            ctx.addIssue({ code: "custom", message: "Response token ranges must be ordered and character-aligned" });
            return;
        }
        end = token.end;
    }
});
